// src/helpers/Global.js
export const Global = {
  url: `https://zafra.wemotion.es/api/`,
  loginPrimary: "mail",
  rango_metros: 1000,
  partes_trabajo: "no",
  silcontrol: "no"
};